module.exports = __webpack_public_path__ + "static/media/fa-light-300.1015dc15.woff";